import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PanelClaro from '../forms/PanelClaro';
import PaymentViewMode from './payment/PaymentViewMode';
import PaymentEditMode from './payment/PaymentEditMode';
import { GetRegion } from '../../constants';
import { payWaySelector } from './MyAccountSelector';
export class PaymentSection extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditMode: false,
    };
    this.changeToEditMode = this.changeToEditMode.bind(this);
    this.changeToViewMode = this.changeToViewMode.bind(this);
  }

  changeToEditMode() {
    this.setState({ isEditMode: true });
  }

  changeToViewMode() {
    this.setState({ isEditMode: false });
  }

  // TODO: REFACTOR -> Método provicional hasta conocer la respuesta de las apis
  getPaymentMethod() {
    return {
      response: {
        paymethodValues: {
          name: '',
          cardNumber: '',
          securityCode: '',
          address: '',
          city: '',
          states: '',
          zipCode: '',
          telefono: '',
          cardType: 0,
          expiryDate_MM: '',
          expiryDate_YY: '',
        },
      },
    };
  }

  selectMode() {
    const states =
      this.props.metadata.states === undefined
        ? JSON.parse('{}')
        : JSON.parse(this.props.metadata.states)[GetRegion()];
    return this.state.isEditMode ? (
      <PaymentEditMode
        states={states}
        changeToViewMode={this.changeToViewMode}
        values={this.getPaymentMethod()}
        viewFunction={this.changeToViewMode}
      />
    ) : (
      <PaymentViewMode changeToEditMode={this.changeToEditMode} />
    );
  }

  render() {
    const { itHasITunes, payway } = this.props;
    const GATEWAYS = _.get(payway, ['gateways']);
    const SHOULD_RENDER =
      GATEWAYS &&
      /(plazavipgate|itunesgate|claropagosgate)/.test(GATEWAYS.join(''));
    return (
      SHOULD_RENDER && (
        <PanelClaro sectionName="micuentamodificarmediodepago">
          {itHasITunes && <h1>ituenss</h1>}
          {this.selectMode()}
        </PanelClaro>
      )
    );
  }
}

PaymentSection.propTypes = {
  itHasITunes: PropTypes.bool,
  payway: PropTypes.shape({}),
  metadata: PropTypes.shape({
    states: PropTypes.shape({}),
  }),
};

PaymentSection.defaultProps = {
  itHasITunes: false,
};

const mapStateToProps = state => ({
  metadata: state.metadata,
  config: state.config,
  translations: state.translations,
  payway: payWaySelector(state),
});

const withConnect = connect(
  mapStateToProps,
  null,
);

export default compose(withConnect)(PaymentSection);
